import {Component, OnDestroy, OnInit} from '@angular/core';
import {Login} from './login';
import {AuthenticationService} from '../../../services/authentication.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ProjectService} from '../../../services/project.service';
import {CurrentUserService} from '../../../services/currentuser.service';
import {NotificationService} from '../../../services/notification.service';
import {ConsentService} from '../../../services/consent.service';

@Component({
  templateUrl: 'login.component.html'
})
export class LoginComponent implements OnInit, OnDestroy {

  model: Login = new Login('', '');

  private loginSubscription;
  private processTokenSubscription;
  private userIdSubscription;
  private projectServiceSubscription;
  private loginWithCredentialsFromStorageSubscription;


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private projectService: ProjectService,
    private currentUserService: CurrentUserService,
    private notificationService: NotificationService,
    private consentService: ConsentService
  ) { }

  ngOnInit(): void {

    if ( this.authenticationService.isAuthorized() ) {
      this.authenticationService.notifySuccessfulLogin(this.currentUserService.getLogin());
      this.router.navigate(['visitors']);
      // console.log( 'VISITOR redirect ')
      return;
    }

    const loginFromStorage = this.currentUserService.getLogin();
    if (loginFromStorage) {
      this.model.username = loginFromStorage;
    }
    const passwordFromStorage = this.currentUserService.getPassword();
    if (passwordFromStorage) {
      this.model.password = passwordFromStorage;
    }

    this.authenticationService.login( this.model.username, this.model.password ).then(
      (ok) => {
        if (ok) {
          this.handleLoginSuccess();
        } else {
          this.handleLoginFailure();
        }
      });

    console.log( 'c' );

    this.route.queryParams.subscribe(
      params => this.handleInputParams(params)
    );

    this.notificationService.disconnect();
  }

  login() {
    this.authenticationService.login(this.model.username, this.model.password).then(
      (ok) => {
        if ( ok ) {
          this.handleLoginSuccess();
        } else {
          this.handleLoginFailure();
        }
      })
  }

  // private hanleLoginResponse(response) {
  //   if (this.authenticationService.isResponseSuccessful(response)) {
  //     this.authenticationService.processAccessTokenResponse(response);
  //     this.handleLoginSuccess();
  //   } else {
  //     this.handleLoginFailure();
  //   }
  // }

  private handleInputParams( params) {
    const fromParamEncoded = params['from'];
    if (fromParamEncoded == null) {
      return;
    }
    const email = atob(fromParamEncoded);
    if (email != null && email.includes('@')) {
      this.model.username = email;
      if (this.model.password != null && email.includes('@')) {
        this.login();
      }
      return;
    }
  }

  private handleLoginSuccess() {
    
    this.authenticationService.setUserIdFromUsername(this.currentUserService.getLogin());
    this.consentService.checkConsent(this.model.username);
    this.router.navigate(['visitors']);
    this.authenticationService.notifySuccessfulLogin(this.model.username);
    // this.initializeProjectsSelector();
    this.projectService.reloadProjects();
  }

  private handleLoginFailure() {
    this.notificationService.displayErrorMesage( 'Login', 
    'Invalid username / password. Click \'Forgot password?\' link below. ' +
      'If you bought the PRO license, make sure you\'re using the same email address you entered on license purchase.', 
    );
    this.currentUserService.setLogin(null);
  }

  // private initializeProjectsSelector() {
  //   if (this.currentUserService.getSelectedProjectId()) {
  //     this.projectServiceSubscription = this.projectService.getProjects().subscribe(
  //       projects => {
  //         if (projects.length > 0) {
  //           this.currentUserService.setSelectedProjectId(projects[0]['id']);
  //         }
  //       }
  //     )
  //   }
  // }

  ngOnDestroy(): void {
    if (this.loginSubscription) {
      this.loginSubscription.unsubscribe();
    }
    if (this.processTokenSubscription) {
      this.processTokenSubscription.unsubscribe();
    }
    if (this.userIdSubscription) {
      this.userIdSubscription.unsubscribe();
    }
    if (this.processTokenSubscription) {
      this.projectServiceSubscription.unsubscribe();
    }
    if (this.loginWithCredentialsFromStorageSubscription) {
      this.loginWithCredentialsFromStorageSubscription.unsubscribe();
    }
  }

}
